import {DateField, Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import {Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField as MUITextField} from '@mui/material';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {ServiceContext} from '../../../../components/Services';
import {joinAddress, saveDate} from '../../../../utilities';

const Core = ({list = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [contacts, setContacts] = useState([]);
  const [contact, setContact] = useState(null);
  const [location, setLocation] = useState('');
  const initialised = useRef(false);
  const {setValue} = useFormContext();

  useEffect(() => {
    if (!initialised.current) {
      initialised.current = true;
      services.contact.getCachedContacts()
        .then(response => setContacts(response.data))
        .catch(() => setContacts([]));
    }
  }, [services]);

  useEffect(() => {
    if (contact) {
      const index = contact.locations.findIndex(({id}) => `${id}` === location);
      if (index >= 0) {
        setValue(`${prefixWithSeparator(prefix)}collection_address`, joinAddress(contact.locations[index], [contact.name]));
      }
    }
  }, [prefix, contact, location, setValue]);

  // noinspection JSValidateTypes
  return (
    <Panes
      entity={list}
      prefix={prefix}
      panes={[
        {
          title: 'Collection Details',
          fields: [
            <DateField
              name="collection_date"
              prefix={prefix}
              label="Collection Date"
              rules={{required: 'Please select a collection date'}}
            />,
            <Box marginY={2}>
              <Autocomplete
                options={contacts}
                value={contact}
                onChange={(e, selected) => setContact(selected)}
                renderInput={(params) => <MUITextField {...params} label="Contact"/>}
                getOptionLabel={(option) => option.name}
              />
            </Box>,
            <Box marginY={2}>
              <FormControl fullWidth disabled={(contact?.locations ?? []).length < 1}>
                <InputLabel id="locationLabel">Location</InputLabel>
                <Select
                  labelId="locationLabel"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  {(contact?.locations ?? []).map((l, i) => (
                    <MenuItem key={i} value={`${l.id}`}>{l.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>,
            <TextField
              name="collection_address"
              prefix={prefix}
              label="Collection Address"
              fieldProps={{multiline: true, rows: 4}}
            />,
          ]
        },
        {
          title: 'Identifiers',
          fields: [
            <TextField
              name="number"
              prefix={prefix}
              label="Customer PO Number"
            />,
            <TextField
              name="dossier"
              prefix={prefix}
              label="Dossier Number"
            />,
            <TextField
              name="container"
              prefix={prefix}
              label="Container Number"
            />,
            <TextField
              name="seal"
              prefix={prefix}
              label="Seal Number"
            />,
          ]
        }
      ]}
      title=""/>
  );
};

Core.onSave = ({collection_date, collection_address, number, dossier, container, seal}) => ({
  collection_date: saveDate(collection_date),
  collection_address,
  number,
  dossier,
  container,
  seal
});

export default Core;
